import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import 'bootstrap/dist/css/bootstrap.min.css';

import { store, link } from './_helpers';
import { App } from './App';
import './index.css'

// setup fake backend
import { configureFakeBackend } from './_helpers';

import axios from 'axios';


axios.defaults.baseURL = `${link}/api/v1`;


let AllApiCallsList = {}

// Add a request interceptor
axios.interceptors.request.use(function (config) {
    // Adding random number as a token for the config url.
    let randomNumber = Math.round(Math.random() * 10000000);
    config.idToken = randomNumber

    // Adding a key with url(remove base url) as unique indentifier for the url to AllApiCallsList object(which assigns on load) with value of a random number assigned to this api request config.
    let urlConfig = config.url

    AllApiCallsList[urlConfig.replace(axios.defaults.baseURL, '') + config.method] = randomNumber
    return config;
  }, function (error) {
    // Do something with request error
    return Promise.reject(error);
  });

axios.interceptors.response.use(response => {
    //check AllApiCallsList unique identifier ie: AllApiCallsList[url]  which equals random number set to IdToken
    if(AllApiCallsList[response.config.url.replace(axios.defaults.baseURL, '') + response.config.method] === response.config.idToken || response.config.url.includes('analytics/participant/list') || response.config.url.includes('analytics/virtual_team/member/list') || response.config.url.includes('analytics/virtual_team/shared_with')) {
        return response
    }else {
        return Promise.reject({
            ...response,
            copyError: 'delayedCopy'
        })
    }

}, error => {
    
    // on 401 reload and re-run js and clear local storage.
    if (error.response.status === 401 || error.response.status === 403) {
        localStorage.clear();
        window.location.reload();
    }
    else {
        //check AllApiCallsList unique identifier ie: AllApiCallsList[url]  which equals random number set to IdToken
        if(AllApiCallsList[error.config.url.replace(axios.defaults.baseURL, '')] === error.config.idToken || error.config.url.includes('analytics/participant/list') || error.config.url.includes('analytics/virtual_team/member/list') || error.config.url.includes('analytics/virtual_team/shared_with')) {
            return Promise.reject(error)
        }else {
            return Promise.reject({
                ...error,
                copyError: 'delayedCopy'
            })
        }
        // // return Promise.reject(error)
    }
})
if (window.navigator && navigator.serviceWorker) {
    navigator.serviceWorker.getRegistrations()
        .then(function (registrations) {
            for (let registration of registrations) {
                registration.unregister();
            }
        });
}
configureFakeBackend();

render(
    <Provider store={store}>
        <App />
    </Provider>,
    document.getElementById('app')
);


// WEBPACK FOOTER //
// ./src/index.js